import Api from './Api';

export default class ApprovalsAPIs extends Api {
  postApproval(accessToken, job) {
    return this.instance.post('approvals', { job }, this.constructor.addAuthorizationHeader(accessToken));
  }
}
